/**
 * Created by mark on 6/27/2019.
 */
import Service from "../../../Services/index";
import moment from "moment";

const SaleReturnProduct = {
    namespaced: true,
    state: {
        saleReturnProductList: [],
        form:{
            id : "",
            cn_number : "",
            date:"",
            status_id : "",
            cause_id: 1,
            reason:"",
            sale_id:"",
            customer_id:"",
            invoice_id:"",
            invoice_back_id: [],
            invoice_back: [],
            sale : null,
            customer : null,
            invoice: null,
            details : [],
            user_id : "",
            transport_fee : 0,
            transport_price_return : [],
            transport_form_customer : []
        },

        /*new form update 13/4/2020*/
        return_form :{
            date : '',
            cause_id : '',
            sale : '',
            customer : '',
            details : [],
            reason : '',
            user_id : "",
            invoice_back: [],
            invoice_back_id : [],
            transport_fee : '',
            discount_promotion : '',
            return_price : 0,
        },
        invoices: [],
        invoices_back : [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search:{
            customer : '',
            cn_number: "",
            product : '',
            date: [],
            invoice : ""
        }

    },
    mutations: {
        GET_SALE_RETURN_PRODUCT:(state,res)=>{
            state.saleReturnProductList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_INVOICE_FROM_CUSTOMER:(state,res)=>{
            state.invoices = res;
        },
        GET_INVOICE_DETAILS:(state,invoice)=>{

        },
        GET_INVOICE_BACK:(state,res)=>{
            state.return_form.invoice_back = res;
        },
        GET_SALE_RETURN_PRODUCT_BY_ID:(state,res)=>{
            state.return_form = res;
        },
        CLEAR_DATA_FORM:(state)=>{
            let currentDate = moment().format("YYYY-MM-DD");
            state.return_form  = {
                date : currentDate,
                cause_id : '',
                sale : '',
                customer : '',
                details : [],
                reason : '',
                user_id : "",
                invoice_back: [],
                invoice_back_id : [],
                transport_fee : '',
                discount_promotion : '',
                return_price : 0,
            };
            state.invoices = [];
        },
        CLEAR_CUSTOMER :(state)=>{
            state.invoices = [];
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                invoice_id: "",
                cn_number: "",
                product : '',
                date: [],
                invoice : "",
            }
        },
        SET_DETAILS : (state,details)=>{
            state.return_form.details = details;
        },
        ADD_PRODUCT: (state, data) => {
            state.return_form.details = [
                ...state.return_form.details,
                {
                    ...data
                }
            ];
        },
        REMOVE_PRODUCT:(state,index)=>{
            state.return_form.details = state.return_form.details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        }
    },
    actions: {
        setSaleReturnProduct({commit}, page) {
            return Service.SaleReturnProduct.getSaleReturnProduct(page).then(res => {
                commit("GET_SALE_RETURN_PRODUCT", res);
            });
        },
        getSaleReturnProductByID({commit},id){
            return Service.SaleReturnProduct.showSaleReturnProduct(id).then(res => {
                console.log(res);
                commit('SET_DETAILS',res.details);
                commit("GET_SALE_RETURN_PRODUCT_BY_ID", res);
            });
        },
        saveSaleReturnProduct({commit},{id,data}){
            console.log(data);
            if(!id){
                return Service.SaleReturnProduct.createSaleReturnProduct(data);
            }
            else{
                return Service.SaleReturnProduct.updateSaleReturnProduct(id,data);
            }
        },
        deleteSaleReturnProduct({commit},id){
            return Service.SaleReturnProduct.deleteSaleReturnProduct(id).then(res=>{
                console.log("delete");
            });
        },
        getCustomerFromSale({commit},sale_id){
            return Service.SaleReturnProduct.getCustomerFromSaleID(sale_id)
        },
        getInvoiceFromCustomer({commit},customer_id){
            return Service.SaleReturnProduct.getInvoiceFromCustomerID(customer_id)
                .then(res=>{
                    commit("GET_INVOICE_FROM_CUSTOMER",res);
                })
        },
        getTransportFromCustomer({commit},customer_id){
            return Service.SaleReturnProduct.getTransportFromCustomer(customer_id)
        },
        getInvoiceDetails({commit},{invoice_id,cause_id}){
            return Service.SaleReturnProduct.getInvoiceDetails(invoice_id,cause_id).then(data=>{
                console.log(data);
                commit("GET_INVOICE_DETAILS",data);
            })
        },
        getInvoiceBack({commit},customer_id){
            return Service.SaleReturnProduct.getInvoiceBack(customer_id).then(data=>{
                commit("GET_INVOICE_BACK",data);
            })
        },
        clearDataForm({commit}){
            commit("CLEAR_DATA_FORM");
        },
        clearCustomer({commit}){
            commit("CLEAR_CUSTOMER");
        },
        search({commit},{page,data}){
            return Service.SaleReturnProduct.searchSaleReturnProduct(page,data).then(res=>{
                commit("GET_SALE_RETURN_PRODUCT",res)
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },

        /* update 14/4/2020 new function*/
        addDetail({commit},detail){
            commit('ADD_PRODUCT',detail)
        },
        removeDetail({commit},index){
            commit('REMOVE_PRODUCT',index);
        },
        getReturnMinPrice({commit},data){
            return Service.SaleReturnProduct.getReturnMinPrice(data);
        },
        calculateDetails({commit},data){
            return Service.SaleReturnProduct.calculateDetails(data).then(res=>{
                commit('SET_DETAILS',res);
            });
        },
        /*update 15/10/2020 new function*/
        generateCn({commit},date){
            return Service.SaleReturnProduct.generateCN(date);
        },
        //create Credit_note
        createCreditnote({commit},data){
            return Service.SaleReturnProduct.createCreditnote(data);
        },
        getCreditNote({commit},page=1){
            return Service.SaleReturnProduct.getCreditNote(page);
        }
    }
};

export default SaleReturnProduct;
